import { ChainId } from '../types';
const ADDRESS_BY_CHAIN = {
    [ChainId.CRONOS_ZK_MAINNET]: {
        H2Router: '0x39aD8C3067281e60045DF041846EE01c1Dd3a853',
        H2Factory: '0x50704Ac00064be03CEEd817f41E0Aa61F52ef4DC',
        AgentFun: '0x18d40Bd95e34d1a4fcaf9027Db11F6988e5B860A',
        WZkCRO: '0xc1bf55ee54e16229d9b369a5502bfe5fc9f20b6d',
        BondingCurve: '0x55F04eF64860Bf4F73bc54DF060f98079Aa5d8F3',
        BondingCurveRouter: '0x4DF884009a8231E69f4e19d93EC5472487636499',
        vUSD: '0x5b91e29Ae5A71d9052620Acb813d5aC25eC7a4A2',
        ZeroAddress: '0x0000000000000000000000000000000000000000',
        WCRO: '0xBCaA34FF9D5BFD0d948b18Cf6Bf39a882F4a1cBD',
    },
    [ChainId.CRONOS_ZK_TESTNET]: {
        H2Router: '0xD3D913594AA7F302b83EfB4c565396933c138b9f',
        H2Factory: '0xA7c976061D244cd92c954210FDc216cE4875002d',
        AgentFun: '0x1AEcb6a1377a1ECBf459212a2eFA223CEbAfac2E',
        WZkCRO: '0xeD73b53197189BE3Ff978069cf30eBc28a8B5837',
        BondingCurve: '0xeFC492fA643B9624087CaB45Aa4d242dF0fD6db2',
        BondingCurveRouter: '0x9B50399c65D892E1830C4D88ec9cB2840f67a7F0',
        vUSD: '0x9553dA89510e33BfE65fcD71c1874FF1D6b0dD75',
        ZeroAddress: '0x0000000000000000000000000000000000000000',
        WCRO: '0x08A6E713f6A9Baa9af5170729448F286e5cc6a2a',
    },
    [ChainId.CRONOS_EVM_MAINNET]: {
        H2Router: '0x145863Eb42Cf62847A6Ca784e6416C1682b1b2Ae',
        H2Factory: '0x3b44b2a187a7b3824131f8db5a74194d0a42fc15',
        AgentFun: '0x96733708C4157218B6E6889eb9E16B1df7873061',
        WZkCRO: '',
        BondingCurve: '0x8D4fd30Bc53E4882973e411FdC9BBcf6b50FE6BE',
        BondingCurveRouter: '0xEbD8b441B640f90B2888150800d37b966004e487',
        vUSD: '',
        ZeroAddress: '0x0000000000000000000000000000000000000000',
        WCRO: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
    },
    [ChainId.CRONOS_EVM_TESTNET]: {
        H2Router: '0x3923345CEADDf3b58A6A9e6F92e073Be4B5daFD2',
        H2Factory: '0x7cEd5C4494D00B503196F2Ef40240Ad39930f1bc',
        AgentFun: '0x942CfEEba73F0B1876E7a0d07948Dc6845c9c5ee',
        WZkCRO: '',
        BondingCurve: '0x18a02807B19F370edDeFe22319521f2965a6Fc49',
        BondingCurveRouter: '0x0f716e576F6EA099F8Cc3937981E56726e6b17be',
        vUSD: '',
        ZeroAddress: '0x0000000000000000000000000000000000000000',
        WCRO: '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4',
    },
};
export const getContractAddress = (chainId, contractName) => {
    return ADDRESS_BY_CHAIN[chainId][contractName];
};
export const getContractAddressMap = (chainId) => ADDRESS_BY_CHAIN[chainId];
